import NGIconButton from 'src/styles/theme/components/NGIconButton';
import { EMediaQuery } from 'src/styles/theme/utils/enums';
import { mq } from 'src/styles/theme/utils/functions';
import styled from 'styled-components';

export const StyledNewsModalContainer = styled.div(
	({ theme }) => `
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 25px 30px 25px 25px;
	border-radius: ${theme.radius.m};

	${mq(
		EMediaQuery.md,
		`
		padding: 0;
		border-radius: unset;
		padding-bottom: ${theme.spacing.l}
	`
	)}
`
);

export const StyledImageContainer = styled.div(
	({ theme }) => `
	position: relative;
	flex-shrink: 0;
	width: 40%;
	padding-bottom: 40%;
	border-radius: ${theme.radius.m};
	border: solid 1px ${theme.colors.dark};
	overflow: hidden;
	filter: drop-shadow(0px 0px 10px ${theme.colors.transparentBlack});

	${mq(
		EMediaQuery.md,
		`
		width: 100%;
		height: 240px;
		padding-bottom: 0;
		border: unset;
		filter: unset;
	`
	)}
`
);

export const StyledDesktopCloseIcon = styled(NGIconButton)(
	({ theme }) => `
	position: absolute;
	right: ${theme.spacing['4xs']};
	top: ${theme.spacing['4xs']};
	padding: 0 !important;
	z-index: 10;
`
);
